import { Injectable } from '@angular/core';
import { DeviceStatusPipe } from '../device-status-pipe';
import { environment } from 'src/environments/environment';

// import { interval } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnhanceDeviceService{

  constructor(
    private deviceStatusPipe: DeviceStatusPipe,
  ) {}

  // ngOnInit() {
  //   // Call setState function every 5 seconds (adjust the interval as needed)
  //   interval(5000)
  //     .subscribe(() => {
  //       this.setState(data); // Call setState function here, assuming 'this.data' is available
  //     });
  // }

  setState(data) {
    // For convenience, formulate an aggregate state property that covers
    // every possible state.
    data.state = 'absent'
    if (data.present) {
      data.state = 'present'
      switch (data.status) {
        case 1:
          data.state = 'offline'
          break
        case 2:
          data.state = 'unauthorized'
          break
        case 3:
          data.state = 'preparing'
          if (data.ready) {
            data.state = 'ready'
            if (data.using) {
              if (data.usage === 'automation') {
                data.state = 'automation'
              }
              else {
                data.state = 'using'
              }
            }
            else {
              if (data.owner) {
                data.state = 'busy'
              }
              else {
                data.state = 'available'
              }
            }
          }
          break
      }
    }
  }

  enhanceDevice(device) {
    device.enhancedName = device.name || device.model || device.serial || 'Unknown';
    
    
    device.enhancedModel = device.model || 'Unknown';
    device.enhancedImage120 = 'assets/x120/_default.jpg';
    device.enhancedImage24 = 'assets/x24/_default.jpg';
    // this has to be there but reason is not discovered
    // device.ios == true ? device.enhancedImage120 = 'assets/x120/_default.jpg' : device.enhancedImage120 = 'assets/x120/' + (device.image || '_default.jpg');
    // device.ios == true ? device.enhancedImage24 = 'assets/x24/_default.jpg' : device.enhancedImage24 = 'assets/x24/' + (device.image || '_default.jpg');
    //ios change
    if (device.platform=='iOS' && device.status === 6 && device.state !== 'present') {
            
      device.enhancedStateAction = this.deviceStatusPipe.transform('preparing','statusNameAction')
      device.enhancedStatePassive = this.deviceStatusPipe.transform('preparing','statusNamePassive')
      return
    } 
    if (device.platform=='iOS' && device.status === 6 && device.state === 'present') {
      
      device.status = 3
      device.state = 'available'
      device.enhancedStateAction = this.deviceStatusPipe.transform('available','statusNameAction')
      device.enhancedStatePassive = this.deviceStatusPipe.transform('available','statusNamePassive')
      return
    }
    if (device.status === 1) {
      
      device.enhancedStateAction = this.deviceStatusPipe.transform('offline','statusNameAction')
      device.enhancedStatePassive = this.deviceStatusPipe.transform('offline','statusNamePassive')
      return
    } 
    if (device.status === 7) {
      
      device.enhancedStateAction = this.deviceStatusPipe.transform('unhealthy','statusNameAction')
      device.enhancedStatePassive = this.deviceStatusPipe.transform('unhealthy','statusNamePassive')
      return
    }
    //ios change
    device.enhancedStateAction = this.deviceStatusPipe.transform(device.state, 'statusNameAction');
    device.enhancedStatePassive = this.deviceStatusPipe.transform(device.state, 'statusNamePassive');
  }


  // enhanceDevice(device) {
  //   device.enhancedName = device.name || device.model || device.serial || 'Unknown';
  //   device.enhancedModel = device.model || 'Unknown';

  //   const screenshot = sessionStorage.getItem(`deviceScreenshot-${device.serial}`);
  //   if (screenshot && screenshot !== 'undefined' && screenshot.trim() !== '') {
  //     const fullUrl = screenshot;
  //     console.log(' Screenshot loaded from sessionStorage:', fullUrl);
  //     device.enhancedImage120 = fullUrl;
  //     device.enhancedImage24 = fullUrl;
  //   } else {
  //     device.enhancedImage120 = 'assets/x120/_default.jpg';
  //     device.enhancedImage24 = 'resources/x24/_default.jpg';
  //   }
  
  //   // iOS specific status overrides
  //   if (device.platform === 'iOS' && device.status === 6 && device.state !== 'present') {
  //     device.enhancedStateAction = this.deviceStatusPipe.transform('preparing', 'statusNameAction');
  //     device.enhancedStatePassive = this.deviceStatusPipe.transform('preparing', 'statusNamePassive');
  //     return;
  //   }
  
  //   if (device.platform === 'iOS' && device.status === 6 && device.state === 'present') {
  //     device.status = 3;
  //     device.state = 'available';
  //     device.enhancedStateAction = this.deviceStatusPipe.transform('available', 'statusNameAction');
  //     device.enhancedStatePassive = this.deviceStatusPipe.transform('available', 'statusNamePassive');
  //     return;
  //   }
  
  //   // Other status overrides
  //   if (device.status === 1) {
  //     device.enhancedStateAction = this.deviceStatusPipe.transform('offline', 'statusNameAction');
  //     device.enhancedStatePassive = this.deviceStatusPipe.transform('offline', 'statusNamePassive');
  //     return;
  //   }
  
  //   if (device.status === 7) {
  //     device.enhancedStateAction = this.deviceStatusPipe.transform('unhealthy', 'statusNameAction');
  //     device.enhancedStatePassive = this.deviceStatusPipe.transform('unhealthy', 'statusNamePassive');
  //     return;
  //   }
  
  //   // Default enhancement
  //   device.enhancedStateAction = this.deviceStatusPipe.transform(device.state, 'statusNameAction');
  //   device.enhancedStatePassive = this.deviceStatusPipe.transform(device.state, 'statusNamePassive');
  // }

  // enhanceDevice(device) {
  //   device.enhancedName = device.name || device.model || device.serial || 'Unknown';
  //   device.enhancedModel = device.model || 'Unknown';

  //   // ALWAYS set the default image as the base layer first
  //   device.enhancedImage120 = {
  //     type: 'default',
  //     baseImage: 'assets/x120/_default.png',  // Always show default first
  //     overlayImage: null,
  //     hasOverlay: false,
  //     showOverlay: false,  // Controls actual display of overlay
  //     containerClass: 'device-image-container',
  //     baseClass: 'device-image-base',
  //     overlayClass: 'device-image-overlay'
  //   };
    
  //   device.enhancedImage24 = {
  //     type: 'default',
  //     baseImage: 'assets/x24/_default.png',   // Always show default first
  //     overlayImage: null,
  //     hasOverlay: false,
  //     showOverlay: false,  // Controls actual display of overlay
  //     containerClass: 'device-image-container small',
  //     baseClass: 'device-image-base',
  //     overlayClass: 'device-image-overlay'
  //   };

  //   // Check for screenshot in sessionStorage
  //   const screenshot = sessionStorage.getItem(`deviceScreenshot-${device.serial}`);
    
  //   // Only if screenshot exists, is valid, and is not corrupted, add it as overlay
  //   if (screenshot && 
  //       screenshot !== 'undefined' && 
  //       screenshot.trim() !== '' &&
  //       !screenshot.includes('corrupted') &&
  //       !screenshot.includes('error')) {
      
  //     const fullUrl = screenshot;
  //     console.log('Screenshot loaded from sessionStorage:', fullUrl);
      
  //     // Update to layered configuration - default stays as base, screenshot as overlay
  //     device.enhancedImage120.type = 'layered';
  //     device.enhancedImage120.overlayImage = fullUrl;
  //     device.enhancedImage120.hasOverlay = true;
  //     device.enhancedImage120.showOverlay = true;  // Only show if valid
  //     device.enhancedImage120.containerClass = 'device-image-container layered';
      
  //     device.enhancedImage24.type = 'layered';
  //     device.enhancedImage24.overlayImage = fullUrl;
  //     device.enhancedImage24.hasOverlay = true;
  //     device.enhancedImage24.showOverlay = true;  // Only show if valid
  //     device.enhancedImage24.containerClass = 'device-image-container layered small';
      
  //     // Add error handling for overlay images
  //     device.enhancedImage120.onOverlayError = () => {
  //       console.warn('Screenshot failed to load for device:', device.serial);
  //       device.enhancedImage120.showOverlay = false;
  //       device.enhancedImage120.containerClass = 'device-image-container';
  //     };
      
  //     device.enhancedImage24.onOverlayError = () => {
  //       console.warn('Screenshot failed to load for device:', device.serial);
  //       device.enhancedImage24.showOverlay = false;
  //       device.enhancedImage24.containerClass = 'device-image-container small';
  //     };
      
  //     // For backward compatibility
  //     device.enhancedImageUrl120 = fullUrl;
  //     device.enhancedImageUrl24 = fullUrl;
  //     device.hasScreenshot = true;
      
  //   } else {
  //     // No screenshot found or corrupted - keep default configuration
  //     console.log('No valid screenshot found, using default image for device:', device.serial);
  //     device.enhancedImageUrl120 = 'assets/x120/_default.png';
  //     device.enhancedImageUrl24 = 'assets/x24/_default.png';
  //     device.hasScreenshot = false;
  //   }
  
  //   // iOS specific status overrides
  //   if (device.platform === 'iOS' && device.status === 6 && device.state !== 'present') {
  //     device.enhancedStateAction = this.deviceStatusPipe.transform('preparing', 'statusNameAction');
  //     device.enhancedStatePassive = this.deviceStatusPipe.transform('preparing', 'statusNamePassive');
  //     return;
  //   }
  
  //   if (device.platform === 'iOS' && device.status === 6 && device.state === 'present') {
  //     device.status = 3;
  //     device.state = 'available';
  //     device.enhancedStateAction = this.deviceStatusPipe.transform('available', 'statusNameAction');
  //     device.enhancedStatePassive = this.deviceStatusPipe.transform('available', 'statusNamePassive');
  //     return;
  //   }
  
  //   // Other status overrides
  //   if (device.status === 1) {
  //     device.enhancedStateAction = this.deviceStatusPipe.transform('offline', 'statusNameAction');
  //     device.enhancedStatePassive = this.deviceStatusPipe.transform('offline', 'statusNamePassive');
  //     return;
  //   }
  
  //   if (device.status === 7) {
  //     device.enhancedStateAction = this.deviceStatusPipe.transform('unhealthy', 'statusNameAction');
  //     device.enhancedStatePassive = this.deviceStatusPipe.transform('unhealthy', 'statusNamePassive');
  //     return;
  //   }
  
  //   // Default enhancement
  //   device.enhancedStateAction = this.deviceStatusPipe.transform(device.state, 'statusNameAction');
  //   device.enhancedStatePassive = this.deviceStatusPipe.transform(device.state, 'statusNamePassive');
  // }

  enhanceDeviceDetails(device) {
    if (device.battery) {
      device.enhancedBatteryPercentage = (device.battery.level / device.battery.scale * 100) + '%';
      device.enhancedBatteryHealth = this.deviceStatusPipe.transform(device.battery.health, 'batteryHealth');
      device.enhancedBatterySource = this.deviceStatusPipe.transform(device.battery.source, 'batterySource');
      device.enhancedBatteryStatus = this.deviceStatusPipe.transform(device.battery.status, 'batteryStatus');
      device.enhancedBatteryTemp = device.battery.temp + '°C';
    }

    if (device.owner) {
      device.enhancedUserProfileUrl = this.enhanceUserProfileUrl(device.owner.email)
      device.enhancedUserName = device.owner.name || 'No name'
    }

    device.enhancedGroupOwnerProfileUrl = this.enhanceUserProfileUrl(device.group.owner.email)
  }

  //Add the below method
  enhanceUserProfileUrl(email) {
  //   let url
  //   let userProfileUrl = (function() {
  //     if (AppState && AppState.config && AppState.config.userProfileUrl) {
  //       return AppState.config.userProfileUrl
  //     }
  //     return null
  //   })()

  //   if (userProfileUrl) {
  //     // Using RFC 6570 URI Template specification
  //     if (userProfileUrl && email) {
  //       url = userProfileUrl.indexOf('{user}') !== -1 ?
  //         userProfileUrl.replace('{user}', email) :
  //         userProfileUrl + email
  //     }
  //   } else if (email.indexOf('@') !== -1) {
  //     url = 'mailto:' + email
  //   } else {
  //     url = '/!#/user/' + email
  //   }
  //   return url
  }

  enhance(device) {
      this.setState(device);
      this.enhanceDevice(device);
      this.enhanceDeviceDetails(device);
    
  }
}
